module.exports = __webpack_public_path__ + "static/the-real-deal-f8f20622c16fb2b2b4709a597f8facd6.jpg";